<template>
  <div class="f-v f-ast">
    <donut-modal-sections-title :title="`${$i18n.t('shoutouts.feature')} are activated!`" />
    <div class="t">Donut just sent you a {{ $i18n.t('shoutouts.shoutout', { count: 1 }) }} in {{ channel.name }}</div>
    <a class="link t-lg bold f-ac m-t" :href="channel.slack_link" target="_blank">
      <span>Check it out in {{ channel.name }}</span>
      <i class="mi md-16 m-l2">open_in_new</i>
    </a>
    <donut-modal-sections-actions
      button-text="Announce Shoutouts"
      cancel-text="Customize Other Settings"
      save-mutation="updateModal"
      :save-args="announceModalArgs"
    />
  </div>
</template>

<script setup>
  import { computed, inject } from 'vue';
  import { useStore } from 'vuex';

  const $i18n = inject('$i18n');
  const { state } = useStore();

  const channel = computed(() => state.modal.data.setupChannel);

  const announceModalArgs = {
    visible: true,
    subcomponent: 'shoutouts-programs-modals-launch-announcement',
    size: 'xl',
    data: { channels: [channel.value] },
  };
</script>
